import { registerRootComparator, getRootComparator, getCompareFunctionFactory } from "./registry.mjs";
import { FIRST_AFTER_SECOND, FIRST_BEFORE_SECOND, DO_NOT_SWAP, sort } from "./engine.mjs";
export { registerRootComparator, getRootComparator, getCompareFunctionFactory, FIRST_AFTER_SECOND, FIRST_BEFORE_SECOND, DO_NOT_SWAP, sort };


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/columnSorting/sortService/index.mjs
// module id = 145
// module chunks = 1